import templateUrl from './autoClearAlerts.tpl.html';

/**
 *
 */
angular.module('signalview.detector.wizard').component('autoClearAlerts', {
    bindings: {
        rule: '<',
    },
    templateUrl,
    controller: [
        '$scope',
        'timeSpanUtils',
        function ($scope, timeSpanUtils) {
            const ctrl = this;

            ctrl.$onInit = $onInit;

            function $onInit() {
                $scope.autoResolve = {
                    isEnabled: !!ctrl.rule.autoResolveAfter,
                    autoResolveAfter: ctrl.rule.autoResolveAfter,
                };
            }

            function validate(v) {
                const valid = timeSpanUtils.validateTimeSpan(v);
                $scope.valid = valid;
                return valid;
            }

            function validateAndUpdate(value) {
                const valid = validate(value);

                if (valid) {
                    ctrl.rule.autoResolveAfter = value;
                } else {
                    ctrl.rule.autoResolveAfter = '';
                }
            }

            $scope.$watch('autoResolve.autoResolveAfter', function (current) {
                if ($scope.autoResolve.isEnabled) {
                    validateAndUpdate(current);
                }
            });

            $scope.$watch('autoResolve.isEnabled', function (current) {
                if (!current) {
                    delete ctrl.rule.autoResolveAfter;
                } else {
                    validateAndUpdate($scope.autoResolve.autoResolveAfter);
                }
            });
        },
    ],
});
